export const RESUME_LINK = "https://drive.google.com/file/d/1XCAKLk7SJyONu_1ZZEmQH3BdDE1JYQjU/view?usp=sharing";
